module.exports = __webpack_public_path__ + "img/resume-import.ec939d19.svg";